import { gql } from '@apollo/client';

export default gql`
  query updateAllBranchsStatus {
    updateAllBranchsStatus {
      ok
      message
      error
    }
  }
`;
